import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { SelfAssessmentComponent } from '../self-assessment.component';

@Component({
  selector: 'app-sa-step-6',
  templateUrl: './sa-step-6.component.html',
  styleUrls: ['./sa-step-6.component.css']
})
export class SaStep6Component {

  constructor(
    public router: Router,
    public ss: SelfAssessmentComponent
  ) { }

  onChange() {
    const value = this.ss.selfAssessmentModel;
    this.ss.userService.saveSelfAssessment(value).subscribe({
      next: (value) => {
          console.log("saveSelfAssessment result: " + value);
      },
    });
  }
  
  _prevButton() { 
    this.router.navigateByUrl("/self-assessment/5");
 }
  _nextButton() { 
    this.router.navigateByUrl("/self-assessment/7");
 }

}
